import classNames from "classnames";

import type {ISearchComboboxSubListProps} from "../types/ISearchComboboxSubListProps";

import * as styles from "./SearchComboboxSubList.module.css";

/** Building numbers under an expanded street: a nested group hanging from a guide line under the icon tile. */
export const SearchComboboxSubList = (props: ISearchComboboxSubListProps) => (
    <div role="group" aria-label={props.label} className={classNames(styles.subList, props.className)} data-testid={props.dataTestId}>
        {props.children}
    </div>
);
import classNames from "classnames";

import type {ISearchComboboxSubListProps} from "../types/ISearchComboboxSubListProps";

import * as styles from "./SearchComboboxSubList.module.css";

/** Building numbers under an expanded street: a nested group hanging from a guide line under the icon tile. */
export const SearchComboboxSubList = (props: ISearchComboboxSubListProps) => (
    <div role="group" aria-label={props.label} className={classNames(styles.subList, props.className)} data-testid={props.dataTestId}>
        {props.children}
    </div>
);
